/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ goods: NonNullable<unknown>, fee: NonNullable<unknown> }} Carrier_Form_Cod_Summary_Breakdown_CustomerInputs */

const vi_carrier_form_cod_summary_breakdown_customer = /** @type {(inputs: Carrier_Form_Cod_Summary_Breakdown_CustomerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`= tiền hàng ${i?.goods}đ + cước ${i?.fee}đ`)
};

/**

* @param {Carrier_Form_Cod_Summary_Breakdown_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_summary_breakdown_customer = /** @type {((inputs: Carrier_Form_Cod_Summary_Breakdown_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Summary_Breakdown_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_summary_breakdown_customer(inputs)
});